<template>
  <v-layout row justify-center>
    <v-dialog v-model="dialog" persistent max-width="400" fullscreen>
      <v-card v-if="isLoadingProductDetail == true">...Loading</v-card>
      <v-card v-if="isLoadingProductDetail == false">
        <v-toolbar color="primary">
          <v-toolbar-title>ข้อมูลสินค้า : {{ productName }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click="$emit('setDialog', false), (reject_msg = '')">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text
          v-if="isLoadingStore == true"
          style="height: calc(100vh - 64px - 81px)"
        >
          <div
            style="
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              height: 100%;
            "
          >
            <v-progress-circular
              :size="50"
              color="primary"
              indeterminate
            ></v-progress-circular>
            <div><br />Loading ...</div>
          </div>
        </v-card-text>
        <v-card-text v-if="isLoadingStore == false" class="pa-0">
          <v-layout
            row
            wrap
            style="height: calc(100vh - 64px - 81px); overflow: auto"
          >
            <v-flex
              xs12
              sm4
              style="border-right: 2px solid #f2f2f2; padding: 24px"
            >
              <div class="text-title">Product Image : &nbsp;</div>
              <div class="img-logo-layout">
                <a
                  :href="
                    'https://storage.googleapis.com/v4-weserve/' +
                    selected_item.product_image
                  "
                  target="_blank"
                  style="text-decoration: none; color: white"
                >
                  <img
                    :src="
                      'https://storage.googleapis.com/v4-weserve/' +
                      selected_item.product_image
                    "
                    class="img-logo"
                  />
                  <span class="img-text">Store Logo</span>
                </a>
              </div>
              <div class="flex-row my-card">
                <div class="text-title">Product Code : &nbsp;</div>
                <div class="text-content">{{ selected_item.product_code }}</div>
              </div>
              <div class="flex-row my-card">
                <div class="text-title">Product Type : &nbsp;</div>
                <div class="text-content">
                  {{ selected_item.product_type_id }}
                </div>
              </div>
              <div class="my-card">
                <div class="text-title">Product Note : &nbsp;</div>
                <div class="text-content">{{ selected_item.product_note }}</div>
              </div>
            </v-flex>
            <v-flex
              xs12
              sm4
              style="border-right: 2px solid #f2f2f2; padding: 24px"
            >
              <div class="flex-row my-card">
                <div class="text-title">Product name TH : &nbsp;</div>
                <div class="text-content">
                  {{ selected_item.product_name_th }}
                </div>
              </div>
              <div class="my-card">
                <div class="text-title">Product Description TH : &nbsp;</div>
                <div class="text-content">
                  {{ selected_item.product_description_th }}
                </div>
              </div>
              <div class="flex-row my-card">
                <div class="text-title">Product name EN : &nbsp;</div>
                <div class="text-content">
                  {{ selected_item.product_name_en }}
                </div>
              </div>
              <div class="my-card">
                <div class="text-title">Product Description EN : &nbsp;</div>
                <div class="text-content">
                  {{ selected_item.product_description_en }}
                </div>
              </div>
              <div class="flex-row my-card">
                <div class="text-title">Product name CN : &nbsp;</div>
                <div class="text-content">
                  {{ selected_item.product_name_cn }}
                </div>
              </div>
              <div class="my-card">
                <div class="text-title">Product Description CN : &nbsp;</div>
                <div class="text-content">
                  {{ selected_item.product_description_cn }}
                </div>
              </div>
              <div
                class="my-card"
                style="display: flex; justify-content: space-between"
              >
                <div>
                  <div class="flex-row">
                    <div class="text-title">Base Price : &nbsp;</div>
                    <div class="text-content">
                      {{ selected_item.product_base_price }}
                    </div>
                  </div>
                  <div class="flex-row">
                    <div class="text-title">Sale Price : &nbsp;</div>
                    <div class="text-content">
                      {{ selected_item.product_sale_price }}
                    </div>
                  </div>
                  <div class="flex-row">
                    <div class="text-title">POS Base Price : &nbsp;</div>
                    <div class="text-content">
                      {{ selected_item.product_pos_base_price }}
                    </div>
                  </div>
                  <div class="flex-row">
                    <div class="text-title">POS Sale Price : &nbsp;</div>
                    <div class="text-content">
                      {{ selected_item.product_pos_sale_price }}
                    </div>
                  </div>
                </div>
                <div>
                  <v-checkbox
                    v-model="selected_item.product_recommend"
                    label="Recomment"
                    hide-details
                    style="margin-top: 0"
                    readonly
                  ></v-checkbox>
                  <v-checkbox
                    v-model="selected_item.product_best_seller"
                    label="Best seller"
                    hide-details
                    style="margin-top: 0"
                    readonly
                  ></v-checkbox>
                </div>
              </div>
            </v-flex>

            <v-flex xs12 sm4 style="padding: 24px">
              <div class="my-card">
                <div class="text-title">Product Option : &nbsp;</div>
                <div class="text-content">
                  <div
                    v-for="(item_option, index) in selected_item.product_option"
                    :key="index"
                  >
                    <v-checkbox
                      label="Require"
                      v-model="item_option.option_require"
                      hide-details
                      readonly
                      style="margin-top: 0"
                    ></v-checkbox>
                    Option Type :
                    {{
                      item_option.option_type == 1
                        ? "Single"
                        : item_option.option_type == 2
                        ? "Multiple"
                        : ""
                    }}
                    <br />
                    {{ "Option" + (index + 1) + " :" }}
                    {{ item_option.option_name_th }}
                    <li
                      v-for="(item_choice, index) in item_option.option_choice"
                      :key="index"
                    >
                      {{ "Choice" + (index + 1) + " :" }}
                      {{ item_choice.choice_name_th }}
                    </li>
                    <v-divider class="my-2" v-if="index - 1" />
                  </div>
                </div>
              </div>

              <div class="my-card">
                <div class="text-title">Promotion Date : &nbsp;</div>
                <div class="text-content">{{ selected_item.product_date }}</div>
              </div>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions style="border-top: 2px solid #f2f2f2">
          <v-textarea
            rows="1"
            outline
            background-color="red"
            label="Reject message"
            v-model="reject_msg"
            hide-details
          ></v-textarea>
          <v-btn
            depressed
            color="red"
            class="white--text"
            @click="rejectProduct()"
            style="height: 57px; margin-left: 8px"
            >reject</v-btn
          >
          <v-btn
            depressed
            color="green darken-1"
            class="white--text"
            @click="approveProduct()"
            style="height: 57px"
            >Approve</v-btn
          >
          <v-btn
            depressed
            color="grey darken-1"
            class="white--text"
            @click="deleteProduct()"
            style="height: 57px"
            >Delete</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: {
    dialog: {
      type: Boolean,
      default() {
        return false;
      },
    },
    isLoadingProductDetail: {},
    productName: {},
    selectedProvince: {},
    // selected_item: {
    //   type: Object,
    //   default() {
    //     return { msg: null };
    //   }
    // }
  },
  data() {
    return {
      reject_msg: "",
      store_detail: {},
      rejecting_product: false,
      approving_product: false,
      deleting_product: false,
      isLoadingStore: false,
    };
  },
  computed: {
    ...mapState({
      selected_item: (state) =>
        state.fetchProductApproveBack.product_approve_detail,
    }),
  },
  watch: {
    async dialog() {},
  },
  methods: {
    async deleteProduct() {
      this.deleting_product = true;
      let configPath = {
        province: this.selectedProvince,
        productId: this.selected_item.product_id,
        productApprove: this.selected_item.product_approve,
      };
      let check = await this.$store.dispatch(
        "fetchProductApproveBack/deleteProductEdit",
        configPath
      );
      this.deleting_product = false;
      if (check == true) {
        this.reject_msg = "";
        this.$emit("setDialog", false);
      }
    },
    async approveProduct() {
      this.approving_product = true;
      let configPath = {
        province: this.selectedProvince,
        productId: this.selected_item.product_id,
        productApprove: this.selected_item.product_approve,
      };
      let check = await this.$store.dispatch(
        "fetchProductApproveBack/approveProductEdit",
        configPath
      );
      this.approving_product = false;
      if (check == true) {
        this.reject_msg = "";
        this.$emit("setDialog", false);
      }
    },
    async rejectProduct() {
      this.rejecting_product = true;
      let form = {
        data: {
          msg: this.reject_msg,
        },
        product_id: this.selected_item.product_id,
        province: this.selectedProvince,
      };
      let check = await this.$store.dispatch(
        "fetchProductApproveBack/rejectProductEdit",
        form
      );
      this.rejecting_product = false;
      if (check == true) {
        this.reject_msg = "";
        this.$emit("setDialog", false);
      }
    },
  },
};
</script>
<style scoped>
.flex-row {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.text-title {
  font-size: 14px;
  font-weight: 500;
  color: #666;
}
.text-content {
  font-size: 16px;
  font-weight: 500;
}
.my-card {
  border: 2px solid rgb(242, 242, 242);
  border-radius: 5px;
  padding: 2px 5px;
  margin-bottom: 10px;
}
.img-logo-layout {
  display: flex;
  justify-content: space-between;
  margin: 15px 0;
  height: 120px;
  width: 120px;
  min-width: 120px;
  position: relative;
  text-align: center;
  color: white;
  font-size: 18px;
  cursor: pointer;
  background: white;
  -webkit-box-shadow: 2px 3px 20px -10px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 2px 3px 20px -10px rgba(0, 0, 0, 0.5);
  box-shadow: 2px 3px 20px -10px rgba(0, 0, 0, 0.5);
  border-radius: 20px;
}
.img-logo {
  height: 100%;
  width: 100%;
  border-radius: 20px;
  object-fit: cover;
}
</style>
